import { useRef, useState } from "react";
import Loader from "./Loader";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../redux/services/apiSlice";

const Announcement = () => {
  const navigate = useNavigate();
  const { languageType } = useSelector((state) => state.homeSlice);
  const { data: announcementsData = [], isLoading: announcementsIsLoading } =
    useGetProtectedApiDataQuery({ url: "announcement", lang: languageType });

  const [isPaused, setIsPaused] = useState(false);
  const tickerRef = useRef(null);

  const togglePlayPause = () => {
    setIsPaused((prev) => !prev);
    if (tickerRef.current) {
      tickerRef.current.style.animationPlayState = isPaused
        ? "running"
        : "paused";
    }
  };

  if (announcementsIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <div className="container">
        <div className="row">
          {" "}
          <div className="col-12 col-sm-11 col-md-11 col-lg-12 ticker-wraper">
            {/* Play / Pause Button */}

            <div className="ticker-wrapper-h">
              <ul className="news-ticker-h" ref={tickerRef}>
                {announcementsData.map((announcement, index) => (
                  <li key={index}>
                    <a
                      title={announcement.title}
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/announcement-detail");
                      }}
                    >
                      {announcement.title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <button
              className="ticker-p-p-btn"
              onClick={togglePlayPause}
              aria-label={
                isPaused ? "Pause announcements" : "Play announcements"
              }
            >
              <i
                className={`fa ${!isPaused ? "fa-pause" : "fa-play"}`}
                aria-hidden="true"
              ></i>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Announcement;
